import { BASE_URL, DASHBOARD_TYPES } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
export class ReportingService {
  public getAlertsAsync(companyId: any, onSuccess: any, onFailure: any) {
    try {
      fetch(`${BASE_URL}/reports/alerts/${companyId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      }).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }
  public async getQuestionnaireReportsByCompany(companyId: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/reports/questionnaire/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public getQuestionnaireReportsByCompanyAsync(
    companyId: any,
    onSuccess: any,
    onFailure: any
  ) {
    try {
      fetch(`${BASE_URL}/reports/questionnaire/${companyId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      }).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }

  public getQuestionnaireReportsByPersonAsync(
    personId: any,
    onSuccess: any,
    onFailure: any
  ) {
    try {
      fetch(`${BASE_URL}/reports/questionnaire/personal/${personId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      }).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }

  getPreUseLHDReportsByCompany(companyId: any, onSuccess: any,
    onFailure: any) {

    try {
      fetch(
        `${BASE_URL}/reports/preuse/LHD/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }
  getPreUseReportsByCompany(companyId: any, type: any, onSuccess: any,
    onFailure: any) {
    let url = "";
    if (type === DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD) {
      url = `${BASE_URL}/reports/preuse/LHD/${companyId}`;
    }
    if (type === DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_CONVEYOR_BELT) {
      url = `${BASE_URL}/reports/preuse/ConveyorBelt/${companyId}`;
    }
    if (url) {
      try {
        fetch(
          url,
          {
            method: "GET",
            headers: AuthUtils.getHeaders(),
            credentials: "include"
          }
        ).then((resp: any) => {
          onSuccess(resp.json());
        });
      } catch (e) {
        onFailure(e);
      }
    } else {
      onFailure("Url missing....");
    }
  }
  getPreUseConveyorBeltReportsByCompany(companyId: any, onSuccess: any,
    onFailure: any) {
    try {
      fetch(
        `${BASE_URL}/reports/preuse/ConveyorBelt/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }

  getPreUseLHDReportsByPerson(companyId: any, personId: any, onSuccess: any,
    onFailure: any) {
    try {
      fetch(
        `${BASE_URL}/reports/preuse/LHD/personal/${personId}/company/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }

  getPreUseReportsByPerson(companyId: any, type: any, personId: any, onSuccess: any,
    onFailure: any) {
    let url = "";
    if (type === DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD) {
      url = `${BASE_URL}/reports/preuse/LHD/personal/${personId}/company/${companyId}`
    }
    if (type === DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_CONVEYOR_BELT) {
      url = `${BASE_URL}/reports/preuse/ConveyorBelt/personal/${personId}/company/${companyId}`
    }
    if (url) {
      try {
        fetch(
          url,
          {
            method: "GET",
            headers: AuthUtils.getHeaders(),
            credentials: "include"
          }
        ).then((resp: any) => {
          onSuccess(resp.json());
        });
      } catch (e) {
        onFailure(e);
      }
    } else {
      onFailure("URL is missing");
    }
  }

  getInspectionsByTypeCategoryAndEquipment(companyId: any, inspectionType: any, category: any, equipment: any, onSuccess: any,
    onFailure: any) {
    try {
      fetch(
        `${BASE_URL}/reports/generic/inspections/company/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders({ inspectionType: inspectionType, category: category, equipment: equipment }),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }


  getGenericReportsByCompany(inspectionType: any, category: any, companyId: any, onSuccess: any,
    onFailure: any) {

    try {
      fetch(
        `${BASE_URL}/reports/generic/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders({ inspectionType: inspectionType, category: category }),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }
  getGenericReportsByPerson(inspectionType: any, category: any, companyId: any, personId: any, onSuccess: any,
    onFailure: any) {
    try {
      fetch(
        `${BASE_URL}/reports/generic/personal/${personId}/company/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders({ inspectionType: inspectionType, category: category }),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }


  public getLHDReportsBetweenTwoDatesByCompanyAsync(
    companyId: any,
    startDate: any,
    endDate: any,
    personId: any,
    onSuccess: any,
    onFailure: any
  ) {

    try {
      fetch(
        `${BASE_URL}/reports/preuse/LHD/${companyId}/between/${startDate}/${endDate}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders({ personId: personId }),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }

  public getPreUseReportsBetweenTwoDatesByCompanyAsync(
    companyId: any,
    type: any,
    startDate: any,
    endDate: any,
    personId: any,
    onSuccess: any,
    onFailure: any
  ) {
    let url = "";
    if (type === DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD) {
      url = `${BASE_URL}/reports/preuse/LHD/${companyId}/between/${startDate}/${endDate}`
    }
    if (type === DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_CONVEYOR_BELT) {
      url = `${BASE_URL}/reports/preuse/ConveyorBelt/${companyId}/between/${startDate}/${endDate}`;
    }
    if (url) {
      try {
        fetch(
          url,
          {
            method: "GET",
            headers: AuthUtils.getHeaders({ personId: personId }),
            credentials: "include"
          }
        ).then((resp: any) => {
          onSuccess(resp.json());
        });
      } catch (e) {
        onFailure(e);
      }
    } else {
      onFailure("URL is missing");
    }
  }

  public getConveyorBeltReportsBetweenTwoDatesByCompanyAsync(
    companyId: any,
    startDate: any,
    endDate: any,
    personId: any,
    onSuccess: any,
    onFailure: any
  ) {

    try {
      fetch(
        `${BASE_URL}/reports/preuse/ConveyorBelt/${companyId}/between/${startDate}/${endDate}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders({ personId: personId }),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }

  public getGenericReportsBetweenTwoDatesByCompanyAsync(
    companyId: any,
    inspectionType: any,
    category: any,
    startDate: any,
    endDate: any,
    personId: any,
    onSuccess: any,
    onFailure: any
  ) {
    try {
      fetch(
        `${BASE_URL}/reports/generic/${companyId}/between/${startDate}/${endDate}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders({ personId: personId, inspectionType: inspectionType, category: category }),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }

  public getQuestionnaireReportsBetweenTwoDatesByCompanyAsync(
    companyId: any,
    startDate: any,
    endDate: any,
    personId: any,
    onSuccess: any,
    onFailure: any
  ) {
    try {
      fetch(
        `${BASE_URL}/reports/questionnaire/${companyId}/between/${startDate}/${endDate}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders({ personId: personId }),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }

  public getQuestionsResponsesAsync(
    companyId: any,
    onSuccess: any,
    onFailure: any
  ) {
    try {
      fetch(`${BASE_URL}/reports/questionnaire/responses/${companyId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      }).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }

  public getQuestionsResponsesByPersonAsync(
    personId: any,
    onSuccess: any,
    onFailure: any
  ) {
    try {
      fetch(
        `${BASE_URL}/reports/questionnaire/responses/personal/${personId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }

  public getQuestionsResponsesBetweenTwoDatesAsync(
    companyId: any,
    startDate: any,
    endDate: any,
    personId: any,
    onSuccess: any,
    onFailure: any
  ) {
    try {
      fetch(
        `${BASE_URL}/reports/questionnaire/responses/${companyId}/between/${startDate}/${endDate}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders({ personId: personId }),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }



  getWorkflowReportsByCompany(companyId: any, onSuccess: any,
    onFailure: any) {
    try {
      fetch(
        `${BASE_URL}/reports/workflow/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }

  public getWorkflowReportsBetweenTwoDatesByCompanyAsync(
    arg: any,
    onSuccess: any,
    onFailure: any
  ) {
    const { companyId,
      compareEndDate,
      compareStartDate,
      inspectionType,
      category,
      personId } = arg;
    console.log(arg)
    try {
      fetch(
        `${BASE_URL}/reports/workflow/${companyId}/between/${compareStartDate}/${compareEndDate}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders({ personId: personId, inspectionType: inspectionType, category: category }),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }
  getWorkflowReportsByPerson(companyId: any, personId: any, onSuccess: any,
    onFailure: any) {
    try {
      fetch(
        `${BASE_URL}/reports/workflow/personal/${personId}/company/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      ).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e) {
      onFailure(e);
    }
  }
}
